import { ReactComponent as ArrowIcon } from 'assets/images/elearning/navigation/arrow_icon.svg';
import clsx from 'clsx';
import { Accordion } from 'components/elearning/navigation/accordion';
import { TopicStatus } from 'components/elearning/topic-status';
import { GoBack } from 'components/universal/go-back';
import { PATHS } from 'constants/routes';
import { useTopic } from 'hooks/useTopic';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { selectIsAnyTaskIncomplete } from 'store/topic/topicSlice';
import { BottomBar } from '../components/BottomBar';
import cls from './course-layout.module.scss';


export const CourseLayout = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'elearning.handHygiene.courseLayout.general',
    });
    const { pathname } = useLocation();
    const { courseData, continueCourse, isFetchingCourseInfo, topicPath, nextTopicLink, previousTopicLink, isSuccessSendAnswer } = useTopic();
    
    const pathElements = topicPath?.split?.('/');
    const currentTopicPath = pathElements?.[3];

    const currentIssue =
        courseData &&
        courseData?.issues?.find?.((issue) =>
            pathname?.includes?.(issue?.path)
        );

    const currentTopic =
        currentIssue &&
        currentIssue?.topics?.find?.((topic) =>
            currentTopicPath?.includes?.(topic?.path)
        );
    
    const newItems = 
        courseData &&
        courseData.issues.map((item) => {
            return item
        });
    
    const isButtonDisabled = useSelector(selectIsAnyTaskIncomplete);
    
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const toggleAccordion = () => setIsAccordionOpen((prevState) => !prevState);
    const clsArrowIcon = clsx(cls.arrowIcon, {
        [cls.arrowIconRotated]: isAccordionOpen,
    });

    const isQuiz = currentTopic?.path === 'quiz';
    useEffect(() => setIsAccordionOpen(false), [pathname]);

    return (
        <div className={cls.layout}>
            <nav className={cls.menu}>
                <GoBack className={`${cls.back} mb-10`} to={PATHS.HAND_HYGIENE}>
                    {t('backButton')}
                </GoBack>
                <a className={cls.openButton} onClick={toggleAccordion}><ArrowIcon className={clsArrowIcon} /></a>
                <Accordion issues={newItems}  isAccordionOpen={isAccordionOpen} />
                <div className={cls.line}></div>
            </nav>
            <div className={cls.container}>
                <div className={cls.content}>
                    <div className={cls.box}>
                        {currentTopic?.is_available ? (
                            <Outlet />
                        ) : (
                            <>
                                {!isFetchingCourseInfo && (
                                    <TopicStatus
                                        title={t('lockTopicTitle')}
                                        description={t('lockTopicDescription')}
                                        buttonText={t('lockTopicButtontext')}
                                        isSuccess
                                        isStandalone
                                        isHideStatusIcon
                                        onSubmit={continueCourse}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
                <BottomBar back={previousTopicLink} next={nextTopicLink} isAvaible={!isButtonDisabled || currentIssue?.is_done} isQuiz={isQuiz } isSuccessSendAnswer={isSuccessSendAnswer} />
            </div>
        </div>
    );
};
